import React from "react";
import maxfashion from "../Images/Projects/maxfashion.png";
import overstock from "../Images/Projects/overstock.png";
import antropology from "../Images/Projects/antropology.png";
import flipkart from "../Images/Projects/flipkart.png";
import trendsy from "../Images/Projects/trendsy.png"
import nemow from "../Images/Projects/nemow.png"
import {
  Box,
  Button,
  Center,
  HStack,
  Heading,
  Image,
  Link,
  ListItem,
  Text,
  UnorderedList,
  VStack,
} from "@chakra-ui/react";

import {FaGithub, FaPlayCircle}from "react-icons/fa"
const projectsData = [
  {
    image: maxfashion,
    name: "Max Fashion",
    description: " Cloned Max-Fashion website.Max Fashion is a Dubai, United Arab Emirates based e-commerce retailer.",
    type: "This is collaborative project built by 4 team members",
    tech_stack: "JavaScript | HTML | CSS ",
    resposnsibility: ["Collecting products Data ","Product Page"],
    gihub:"https://github.com/Sadanand012/Max_Fashion",
    live:"https://maxfashioncopy.netlify.app/"
  },
  {
    image: overstock,
    name: "Overstock",
    description: "A tech-driven online retailer located near Salt Lake City in the shadow of the Wasatch Mountains. Its a billion-dollar online retailer.",
    type: "This is individual project built in 4 days",
    tech_stack:"React | ChakraUI | JavaScript | HTML | CSS | GIT",
    resposnsibility: ["Home Page","SignIn SignUp","Collecting products Data ","Product Page ,SinglePorduct Page ,Cart"],
    gihub:"https://github.com/MadhukarKakade/humdrum-town-8956",
    live:"https://overstock-copy.netlify.app/"

  },
  {
    image: trendsy,
    name: "Trendsy",
    description: "Trendsy is a clone of Mintra website, which is used to shop men, women, girls, boys fashion and lifestyle related E-commerce website",
    type: "This is collaborative project built by 5 team members",
    tech_stack: "React | Node | Express | MongoDB | Redux | ChakraUI | JavaScript | HTML | CSS ",
    resposnsibility: ["Bulding Home page","Cart Page","Navbar","Footer"],
    gihub:"https://github.com/Shalini1908/Trendsy-Myntra-Clone",
    live:"https://trendsy.vercel.app/"
  },
  {
    image: nemow,
    name: "Nemow",
    description: "Nemow is an e-commerce website where all types of Skincare, Eyecare, Hairstyle and many more related products are available for men, women and kids",
    type: "This is collaborative project built by 5 team members",
    tech_stack: "React | Redux | ChakraUI | JavaScript | HTML | CSS | GIT",
    resposnsibility: ["Creating Admin page","Dashboard"],
    gihub:"https://github.com/gprasadbhat948231/sephora.com",
    live:"https://nemow.vercel.app/"
  },
  {
    image: antropology,
    name: "Anthropologie",
    description: "Anthropologie is a unique full-lifestyle shopping destination with a mostly exclusive assortment of clothing, shoes, accessories, beauty, furniture, home décor, garden, bridal, and more.",
    type: "This is collaborative project built by 5 team members",
    tech_stack: "JavaScript | HTML | CSS | GIT",
    resposnsibility: ["Collecting products Data ","Product Page"],
    gihub:"https://github.com/gaurav7ingh/Anthropologie",
    live:"https://anthropologie-1.netlify.app/index.html"
  },
  {
    image: flipkart,
    name: "Flipkart",
    description: "Flipkart is an Indian e-commerce company.It sells product categories such as consumer electronics, fashion, home essentials, groceries, and lifestyle products.",
    type: "This is collaborative project built by 5 team members",
    tech_stack:  " React | ChakraUI | Redux | JavaScript | HTML | CSS | GIT",
    resposnsibility: ["Collecting products Data ","Product Page","Dynamic Filtering Functionality"],
    gihub:"https://github.com/alalUDDIN123/absent-carpenter-3793",
    live:"https://masai-kart.netlify.app/"
  },
];

const Projects = () => {
  return (
    <Box >
     
      <Box pt="10px">
        <Heading color="#00ade7" size="lg">
        My Amazing Work
        </Heading>
      </Box>
      {projectsData.map((project,i)=><VStack justify="center"  key={150+i} p="15px" mt="15px" spacing="10px"  boxShadow="0px 0px 20px #7bdeff"  fontSize={["xs",null,"sm",null,"lg"]} >
        <Heading size={["sm",null,"lg",null,"xl"]} color="#2a455e">{project.name} </Heading>
        <Center w={"60%"} m="auto">
          <Image src={project.image} alt={project.name} w="100%" />
        </Center>
        <HStack spacing={{base:"40px", lg:"70px"}} justify="center">
          <Link href={project.gihub}  isExternal >
            <Button  size={{base:"xs",md:"sm", lg:"md"}} colorScheme="blue" variant="outline" leftIcon={<FaGithub/>}>Code</Button>
          </Link>
          <Link href={project.live} isExternal>
           
            <Button  size={{base:"xs",md:"sm", lg:"md"}}colorScheme="pink" rightIcon={<FaPlayCircle />}>Live</Button>
          </Link>
        </HStack>
        <Text w="80%">
          {project.description}
        </Text>
        <Heading size={["xs",null,"sm","md"]} color="#3f2c1b">Tech-Stack</Heading>
        <Text>{project.tech_stack}</Text>
        <Heading size={["xs",null,"sm","md"]} color="#3f2c1b">Areas of Responsibility</Heading>
        
        <UnorderedList alignContent={"center"} >
          {project.resposnsibility.map((task,i)=><ListItem  key={250+i}  textAlign="start">{task}</ListItem>)}
        </UnorderedList>
      </VStack>)}
    </Box>
  );
};

export default Projects;
